import type { C1_Room } from "./C1_Room";
import type { C1_Wall } from "./C1_Wall";
import type { C1_Project } from "./C1_Project";

/** Thickness follows this segment's room boundary, independently of collinear neighbors. */
export function roomWallThickness(room: C1_Room, wall: C1_Wall, project: C1_Project): number {
  return room.isExteriorSegment(wall)
    ? project.settings.wallThicknessExterior
    : project.settings.wallThicknessInterior;
}